import {WebSocketProvider} from "./service/WebSocketProvider";
import {WebsocketProviderModuleConfiguration} from "./websocket-provider.module.configuration";
import {WebSocketService} from "./service/WebSocketService";
import {WebSocketServiceName} from "../utils/names/serviceNames";

WebsocketProviderModuleConfiguration
    .createNewModule()
    .provider('$wsClient', WebSocketProvider)
    .service(WebSocketServiceName, WebSocketService.instance);